import { render, staticRenderFns } from "./SignatureSetup.vue?vue&type=template&id=5913cbd4"
import script from "./SignatureSetup.vue?vue&type=script&lang=js"
export * from "./SignatureSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports